import { CarrierService } from "./CarrierService";
import { Company } from "./Company";
import { Media } from "./Media";
import { Shipment } from "./Shipment";
import { ShippingFile } from "./ShippingFile";
import { ShippingRecordDispute } from "./ShippingRecordDispute";

export type ShippingRecordCode = `DOS${number}`;

export enum ShippingRecordStatus {
  CANCELED = "CANCELED",
  DRAFT = "DRAFT",
  TO_SHIP = "TO_SHIP",
  SHIPPED = "SHIPPED",
  DELIVERED = "DELIVERED",
  COLLECTED = "COLLECTED",
}

export enum DeliveryType {
  CHARTERING = "chartering",
  COURIER = "courier",
  EXPRESS = "express",
  MESSAGING = "messaging",
  PROVISIONING = "provisioning",
}

export enum ProofOfDeliveryType {
  RECEIVED = "Reçue",
  NOT_RECEIVED = "Non reçue",
}

export type TotalParcelValues = {
  height: number;
  loadingMeters: number;
  quantity: number;
  weight: number;
};

export type ShippingRecord = {
  id: string;
  code: ShippingRecordCode;
  createdAt: string;
  status: ShippingRecordStatus;
  totalParcel?: TotalParcelValues;
  updatedAt: Date | null;
  shippyProShippingId: string | null;
  carrierReference: string | null;
  carrierTrackingLink: string | null;
  deliveryType: DeliveryType | null;
  agencyCompanyId: string | null;
  agencyCompany?: Company;
  carrierCompanyId: string | null;
  carrierCompany?: Company;
  commissionCompanyId: string | null;
  commissionCompany?: Company;
  carrierServiceId?: string | null;
  carrierService?: CarrierService;
  shipments: Shipment[];
  wishedDeliveryDate: string | Date | null;
  wishedShippingDate: string | Date | null;
  expectedDeliveryDate: string | Date | null;
  notes: string;
  price?: number;
  withGasoil?: boolean;
  shippingRecordDisputes?: ShippingRecordDispute[];
  statusHistory?: ShippingRecordStatusHistory[];
  files?: ShippingFile[];
  media?: Media[];

  _count?: {
    shippingRecordDisputes?: number;
  };

  // TO REMOVE
  authorUserId?: string;
  authorName?: string;
};

export type ShippingRecordHistory = {
  id: string;
  createdAt: Date | string;
  authorUserId: string;
  authorName: string;
  shippingRecordId: string;
  oldValue: string;
  newValue: string;
  field: string;
};

export type ShippingRecordStatusHistory = {
  createdAt: Date | string;
  createdBy: string;
  createdById: string;
  date: Date | string;
  id: string;
  shippingRecordId: string;
  status: ShippingRecordStatus;
  updatedAt: Date | string;
  updatedBy: string;
  updatedById: string;
};
